"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const __1 = require("..");
function useSubmit(suppressErrorMessage) {
    const theme = (0, react_jss_1.useTheme)();
    const fieldsData = react_1.default.useContext(__1.FieldsContext);
    const setValue = react_1.default.useContext(__1.SetValueContext);
    const submit = (e, callback, reset) => {
        var _a;
        e.preventDefault();
        if ((0, __1.formHasErrors)(fieldsData)) {
            // Trigger valdiation check of all fields to prevent submitting before debounce etc.
            Object.entries(fieldsData).forEach(([key, data]) => {
                const { value, mandatory, type } = data;
                setValue(key, value, mandatory, { type });
            });
            // TODO: Turn back the suppressErrorMessage prop support on TS.
            if (!suppressErrorMessage && (theme === null || theme === void 0 ? void 0 : theme.errorNotificationFunc) && ((_a = theme.textLabels) === null || _a === void 0 ? void 0 : _a.formInvalid)) {
                theme.errorNotificationFunc(theme.textLabels.formInvalid);
            }
        }
        else {
            callback && callback((0, __1.getValues)(fieldsData));
            reset && setValue();
        }
    };
    return submit;
}
exports.default = useSubmit;
